import axios from "axios";

const API = axios.create({
    baseURL: "https://api.fingain.app/api",
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// REQUEST INTERCEPTOR
API.interceptors.request.use(

    (config) => {

        const token =
            localStorage.getItem("token");

        if (token) {

            config.headers.Authorization =
                `Bearer ${token}`;

        }

        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

export default API;